import { CircleCheck } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionApprove(props) {

    const { text, route_name, onClick, skipPermission = false } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))
    const canShow = skipPermission || permission?.some(val => val.sub_action_name === route_name)

    return (
        <>
            {canShow &&
                <CircleCheck size={16} className='action_btn text-success me-3'
                    onClick={onClick}
                    data-tooltip-id='approve'
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                />
            }

            <Tooltip id='approve' className='bg-success tooltip_msg' />
        </>
    )
}
